module.exports = __webpack_public_path__ + "assets/img/banner3.bed1c1bb.png";